if (!customElements.get('urgency-countdown')) {
  customElements.define(
    'urgency-countdown',
    class UrgencyCountdown extends HTMLElement {
      connectedCallback() {
        this.valueEl = this.querySelector('.product__countdown-value');
        this.endDate = new Date(this.dataset.endDate.replace(' ', 'T'));

        if (!this.valueEl || Number.isNaN(this.endDate.getTime())) {
          this.remove();
          return;
        }

        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const diff = this.endDate.getTime() - Date.now();

        if (diff <= 0) {
          clearInterval(this.interval);
          this.setAttribute('hidden', '');
          return;
        }

        const days = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);

        const parts = [];
        if (days > 0) parts.push(`${days}d`);
        parts.push(String(hours).padStart(2, '0'));
        parts.push(String(minutes).padStart(2, '0'));
        parts.push(String(seconds).padStart(2, '0'));

        this.valueEl.textContent = parts.join(':');
      }
    }
  );
}
